import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Space, Tag, Typography, Popconfirm, message, Input } from 'antd';
import { EyeOutlined, FilePdfOutlined, SafetyCertificateOutlined, EditOutlined,
  DeleteOutlined, SnippetsOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import api from '../services/api';

// Guia "Estanqueidade" da pagina de Laudos. Componente proprio para nao
// mexer no carregamento das outras listas.
const { Text } = Typography;
const BASE = '/testes-estanqueidade';

const abrirBlob = (data) => window.open(URL.createObjectURL(new Blob([data], { type: 'application/pdf' })), '_blank');
const erroDe = async (e, padrao) => {
  try { return JSON.parse(await e.response.data.text()).erro || padrao; } catch (x) { return e?.response?.data?.erro || padrao; }
};

export default function ListaEstanqueidade() {
  const navigate = useNavigate();
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [busca, setBusca] = useState('');

  const carregar = async () => {
    setCarregando(true);
    try { const r = await api.get(BASE); setLista(r.data || []); }
    catch { message.error('Erro ao carregar os testes de estanqueidade'); }
    finally { setCarregando(false); }
  };
  useEffect(() => { carregar(); }, []);

  const ver = async (r) => {
    try { abrirBlob((await api.get(BASE + '/' + r.id + '/pdf/visualizar', { responseType: 'blob' })).data); }
    catch (e) { message.warning('PDF ainda não gerado. Use o botão vermelho para gerar.'); }
  };
  const gerar = async (r, forcar) => {
    message.loading({ content: 'Gerando PDF...', key: 'est', duration: 0 });
    try {
      const resp = await api.get(BASE + '/' + r.id + '/pdf' + (forcar ? '?forcar=1' : ''), { responseType: 'blob', timeout: 180000 });
      message.destroy('est'); abrirBlob(resp.data); carregar();
    } catch (e) {
      message.destroy('est');
      if (e?.response?.status === 409 && window.confirm('Este laudo já está assinado. Gerar um novo PDF apaga a assinatura. Continuar?')) return gerar(r, true);
      message.error(await erroDe(e, 'Erro ao gerar PDF'));
    }
  };
  const assinar = async (r) => {
    if (!window.confirm('Assinar digitalmente o laudo ' + (r.codigo || '') + '?')) return;
    message.loading({ content: 'Assinando...', key: 'esta', duration: 0 });
    try { await api.post(BASE + '/' + r.id + '/pdf/assinar', {}, { timeout: 120000 }); message.success({ content: 'PDF assinado!', key: 'esta' }); }
    catch (e) { message.error({ content: 'Erro ao assinar: ' + (e?.response?.data?.erro || e.message), key: 'esta' }); }
  };
  const anotacao = async (r, gerarNova) => {
    message.loading({ content: gerarNova ? 'Gerando anotação...' : 'Abrindo anotação...', key: 'estn', duration: 0 });
    try {
      const resp = gerarNova
        ? await api.post('/anotacoes/estanqueidade/' + r.id, {}, { responseType: 'blob', timeout: 120000 })
        : await api.get('/anotacoes/estanqueidade/' + r.id, { responseType: 'blob' });
      message.destroy('estn'); abrirBlob(resp.data);
    } catch (e) {
      message.destroy('estn');
      message.warning(await erroDe(e, gerarNova ? 'Erro ao gerar a anotação' : 'Anotação ainda não gerada. Use o botão laranja para gerar.'));
    }
  };
  const excluir = async (r) => {
    try { await api.delete(BASE + '/' + r.id); message.success('Laudo excluído'); carregar(); }
    catch { message.error('Erro ao excluir'); }
  };

  const t = busca.trim().toLowerCase();
  const filtrada = !t ? lista : lista.filter((r) => [r.codigo, r.tag, r.razao_social, r.nome_cliente, r.numero_os, r.tipo_equipamento]
    .some((v) => String(v || '').toLowerCase().indexOf(t) >= 0));

  return (
    <Card>
      <Space style={{ marginBottom: 12, width: '100%', justifyContent: 'space-between' }}>
        <Text type="secondary">Testes de estanqueidade pelo método de bolha. O laudo nasce da OS (Criar Laudo → Estanqueidade).</Text>
        <Input.Search allowClear placeholder="Buscar código, TAG, cliente, OS" style={{ width: 300 }}
          value={busca} onChange={(e) => setBusca(e.target.value)} />
      </Space>
      <Table rowKey="id" size="small" loading={carregando} dataSource={filtrada} scroll={{ x: 1100 }}
        locale={{ emptyText: 'Nenhum teste de estanqueidade.' }}
        columns={[
          { title: 'Ações', width: 260, render: (_, r) => (
            <Space size={2}>
              <Button icon={<EditOutlined />} size="small" type="primary" title="Editar" onClick={() => navigate(BASE + '/' + r.id)} />
              <Button icon={<EyeOutlined />} size="small" style={{ color: '#1890ff', borderColor: '#1890ff' }} title="Visualizar PDF" onClick={() => ver(r)} />
              <Button icon={<FilePdfOutlined />} size="small" style={{ color: '#cf1322', borderColor: '#cf1322' }} title="Gerar novo PDF" onClick={() => gerar(r)} />
              <Button icon={<SafetyCertificateOutlined />} size="small" style={{ color: '#52c41a', borderColor: '#52c41a' }} title="Assinar PDF" onClick={() => assinar(r)} />
              <Button icon={<SnippetsOutlined />} size="small" style={{ color: '#d46b08', borderColor: '#d46b08' }} title="Ver anotação do livro" onClick={() => anotacao(r, false)} />
              <Button icon={<SnippetsOutlined />} size="small" style={{ color: '#d46b08', borderColor: '#d46b08', background: '#fff7e6' }} title="Gerar anotação do livro" onClick={() => anotacao(r, true)} />
              <Popconfirm title="Excluir este laudo?" description="Não dá para desfazer." okText="Excluir" cancelText="Cancelar" onConfirm={() => excluir(r)}>
                <Button icon={<DeleteOutlined />} size="small" danger title="Excluir" />
              </Popconfirm>
            </Space>) },
          { title: 'Código', dataIndex: 'codigo', width: 120, render: (v) => (v ? <Text strong style={{ color: '#1a3c5e' }}>{v}</Text> : <Tag>a gerar</Tag>) },
          { title: 'Cliente', dataIndex: 'razao_social', render: (v, r) => v || r.nome_cliente },
          { title: 'TAG', dataIndex: 'tag', width: 110, render: (v) => v || '-' },
          { title: 'Equipamento', dataIndex: 'tipo_equipamento', width: 140, render: (v, r) => (v === 'Outro' ? r.tipo_equipamento_outro : v) || '-' },
          { title: 'Resultado', dataIndex: 'resultado', width: 120, render: (v) => (v === 'estanque' ? <Tag color="green">Estanque</Tag>
            : v === 'vazamento' ? <Tag color="red">Vazamento</Tag> : <Tag>—</Tag>) },
          { title: 'OS', dataIndex: 'numero_os', width: 120, render: (v) => v || '-' },
          { title: 'Data', dataIndex: 'data_inspecao', width: 105, render: (v) => (v ? dayjs(String(v).substring(0, 10)).format('DD/MM/YYYY') : '-') },
          { title: 'Próximo teste', dataIndex: 'proximo_teste', width: 115, render: (v) => (v ? dayjs(String(v).substring(0, 10)).format('DD/MM/YYYY') : '-') },
        ]} />
    </Card>
  );
}
